import React, { useState, useRef } from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const fallbackValue = '';

const TextField = ({label, name, help, onChange, placeholder, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [height, setHeight] = useState('70px');
    const fieldRef = useRef();

    useFieldPanelHelper(name, value, isValid);

    const handleChange = (e) => {
        updateField(name, e.target.value);
        onChange && onChange(e.target.value);
        setHeight(Math.max(70, fieldRef.current.scrollHeight) + 'px');
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <textarea className="block w-full border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6"
            ref={fieldRef}
            style={{height}}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={isDisabled}
        />

    </CommonFieldWrapper>
}

export default TextField;
